export const SITE_NAME = 'Bibliona';

export const SITE_URLS = {
  fr: 'https://fr.bibliona.com',
  en: 'https://en.bibliona.com',
};

export function buildPageUrl(lang, routePath = '/') {
  const siteUrl = SITE_URLS[lang] || SITE_URLS.en;
  return routePath === '/' ? `${siteUrl}/` : `${siteUrl}${routePath}`;
}
